import { GetterTree, Getter } from 'vuex';
import { RootState} from '@/store/types';
import { EtabState} from './types';

export const getlistEtablissement : Getter<EtabState, RootState> = state => state.listEtablissements || [] ;

export const getCurrentEtablissement: Getter<EtabState,RootState> 
= state => state.currentEtab || { id: -1, nom: "", icon: "" }; 

export const getters: GetterTree<EtabState, RootState>={
  getlistEtablissement,
  getCurrentEtablissement
}